import React, { useEffect } from 'react';
import { SignupPrompt } from '../../components/perksLanding/signupPrompt/SignupPrompt';
import { PerksBenefit } from '../../components/perksLanding/perksBenefit/PerksBenefit';
import IconPerksCake from '../../../../../../assets/svg/icon-perks-cake.svg';
import IconPerksMegaphone from '../../../../../../assets/svg/icon-perks-megaphone.svg';
import IconPerksAlerts from '../../../../../../assets/svg/icon-perks-alerts.svg';
import IconPerksDiscounts from '../../../../../../assets/svg/icon-perks-discounts.svg';
import TrophyIllustratedIcon from '@jbhi-fi/lanyard-ui/components/Icons/TrophyIllustrated';
import { setPerksLandingReturnUrl } from '../../../perksInfo/utils';
import { styles } from './PerksLanding.css';
import { PerksLandingHeader } from './PerksLandingHeader';
import { perksLandingMessages } from '../../../../../../global';
import { MarkdownBlock } from '@jbhi-fi/components/src/MarkdownBlock';
import { PerksContainer } from '@jbhi-fi/components/src/PerksContainer';

export const PerksLanding = (): JSX.Element => {
  const params = new URLSearchParams(new URL(window.location.href).searchParams.toString() ?? '');
  !params.has('pageTheme') && params.append('pageTheme', 'perks');
  const returnUrl = `/account/login?${params.toString()}`;

  const themeVal = (name: keyof perksLandingMessages) => {
    if (!window.Jbhifi.perksMessaging) return '';
    return window.Jbhifi.perksMessaging[name] || '';
  };

  useEffect(() => {
    setPerksLandingReturnUrl();
  }, []);

  const perksBenefits = [
    {
      heading: 'couponsTitle',
      content: 'couponsMessage',
      icon: <IconPerksAlerts className={styles.benefitLogo} />,
      enabled: 'couponsEnabled',
    },
    {
      heading: 'discountsTitle',
      content: 'discountsMessage',
      icon: <IconPerksDiscounts className={styles.benefitLogo} />,
      enabled: 'discountsEnabled',
    },
    {
      heading: 'notificationsTitle',
      content: 'notificationsMessage',
      icon: <IconPerksMegaphone className={styles.benefitLogo} style={{ transform: 'rotate(-9.7deg)' }} />,
      enabled: 'notificationsEnabled',
    },
    {
      heading: 'birthdaysTitle',
      content: 'birthdaysMessage',
      icon: <IconPerksCake className={styles.benefitLogo} />,
      enabled: 'birthdaysEnabled',
    },
    {
      heading: 'compsTitle',
      content: 'compsMessage',
      icon: <TrophyIllustratedIcon className={styles.benefitLogoTrophy} />,
      enabled: 'compsEnabled',
    },
  ];

  return (
    <PerksContainer>
      <div className={styles.container}>
        <PerksLandingHeader />
        <div className={styles.pageWrapper}>
          <div className={styles.contentWrapper}>
            <div className={styles.leftSectionWrapper}>
              <div className={styles.leftSection}>
                <div className={styles.typeWrapper}>
                  <p className={styles.introText}>
                    Join JB Hi-Fi Perks and you&lsquo;ll start getting free member benefits straight away.
                  </p>
                  <div className={styles.benefitsContainer}>
                    {perksBenefits.map((benefit, index) =>
                      themeVal(benefit.enabled as keyof perksLandingMessages) ? (
                        <PerksBenefit
                          key={index}
                          heading={themeVal(benefit.heading as keyof perksLandingMessages)}
                          content={themeVal(benefit.content as keyof perksLandingMessages)}
                          icon={benefit.icon}
                          isDomCasual
                        />
                      ) : null
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.rightSectionWrapper}>
              <div className={styles.rightSection}>
                <SignupPrompt
                  heading="Let the perks begin!"
                  customerEmail={window.Jbhifi?.customerEmail}
                  returnUrl={returnUrl}
                  disclaimer={
                    <MarkdownBlock components={{ p: 'span' }}>
                      {window.Jbhifi.perksMessaging?.disclaimer || ''}
                    </MarkdownBlock>
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PerksContainer>
  );
};
